// removed by extract-text-webpack-plugin
module.exports = {"container":"G476783","nameInput":"G561aae"};